var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01192 11.9216C6.75309 11.9216 6.54917 11.8118 6.33741 11.553L4.14133 8.83924C4.03153 8.69022 3.96094 8.52552 3.96094 8.35297C3.96094 8.00002 4.23545 7.71767 4.58055 7.71767C4.79231 7.71767 4.98055 7.80395 5.15309 8.03924L6.9727 10.3922L10.5178 4.72159C10.659 4.4863 10.8551 4.36865 11.0668 4.36865C11.3962 4.36865 11.71 4.58826 11.71 4.94904C11.71 5.12159 11.6158 5.30199 11.5217 5.45885L7.64721 11.553C7.48251 11.7961 7.27074 11.9216 7.01192 11.9216Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.3686 16 16 12.3765 16 8C16 3.63137 12.3608 0 7.99216 0C3.61569 0 0 3.63137 0 8C0 12.3765 3.62353 16 8 16ZM7.99614 14.8049C4.21741 14.8049 1.19922 11.7787 1.19922 8C1.19922 4.22927 4.2094 1.19507 7.98814 1.19507C11.7589 1.19507 14.7931 4.22927 14.8011 8C14.8091 11.7787 11.7669 14.8049 7.99614 14.8049Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CheckmarkCircle.e654890610a3283952e567fd4cde7f0f.svg";